import * as React from 'react';
const SatispayIcon = props => {
  const fill = props.color ? props.color : '#fff';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="metodi_pagamento_icon"
      data-name="metodi pagamento icon"
      viewBox="0 0 123.22 29"
      {...props}
    >
      <defs>
        <style>{`.cls-1{fill:${fill}}`}</style>
      </defs>
      <g id="g18">
        <g id="g88">
          <g id="g90">
            <g id="g96">
              <path
                id="path98"
                d="M36.35 18.91h.22c1.26.27 2.39.46 3.49.46 1.67 0 2.87-.4 2.87-1.83 0-2.63-6.53-1.58-6.53-5.94 0-2.36 2.2-3.63 4.97-3.63 1.1 0 2.2.16 3.22.48v1.99h-.21c-1.16-.38-2.15-.54-3.03-.54-1.32 0-2.69.3-2.69 1.69 0 2.5 6.53 1.5 6.53 5.72 0 3.06-2.47 3.98-5.21 3.98-1.34 0-2.69-.19-3.63-.4V18.9Z"
                className="cls-1"
              />
            </g>
            <g id="g100">
              <path
                id="path102"
                d="M67.16 20.82c-.75.27-1.61.48-2.69.48-1.32 0-3.38-.3-3.38-3.33v-7.74h-1.67V8.35h1.67V5.34l1.91-.4h.21v3.41h4.14v1.88h-4.14v7.68c0 1.37 1.16 1.48 1.69 1.48s1.4-.19 2.07-.4l.19 1.83Z"
                className="cls-1"
              />
            </g>
            <g id="g104">
              <path
                id="path106"
                d="M75.02 18.91h.21c1.26.27 2.39.46 3.49.46 1.67 0 2.87-.4 2.87-1.83 0-2.63-6.53-1.58-6.53-5.94 0-2.36 2.2-3.63 4.97-3.63 1.1 0 2.2.16 3.22.48v1.99h-.21c-1.16-.38-2.15-.54-3.03-.54-1.32 0-2.69.3-2.69 1.69 0 2.5 6.53 1.5 6.53 5.72 0 3.06-2.47 3.98-5.21 3.98-1.34 0-2.69-.19-3.63-.4V18.9Z"
                className="cls-1"
              />
            </g>
            <g id="g108">
              <path
                id="path110"
                d="M88.86 19.1c.83.13 1.72.27 2.85.27 2.63 0 4.3-1.67 4.3-4.92 0-3.01-.99-4.54-3.14-4.54-1.26 0-2.66.54-4 1.72v7.47ZM86.71 8.38l1.88-.4h.27v1.64c1.26-.94 2.63-1.64 4.49-1.64 2.77 0 4.91 1.96 4.91 6.15s-2.15 7.17-6.63 7.17c-1.05 0-1.88-.13-2.77-.32v6.26l-1.88.4h-.27V8.38Z"
                className="cls-1"
              />
            </g>
            <g id="g112">
              <path
                id="path114"
                d="m116.06 20.79-4.33-12.44h2.47l3.04 9.78h.19l3.34-9.78h2.44l-4.74 13.05c-1.13 3.22-2.53 4.78-4.84 6.23l-1.21-1.56c2.34-1.66 2.93-2.61 3.81-4.78"
                className="cls-1"
              />
            </g>
            <g id="g116">
              <path
                id="path118"
                d="m107.71 15.1-3.46.51c-.91.13-1.93.51-1.93 1.96 0 1.05.73 1.77 1.83 1.77 1.18 0 2.53-.75 3.57-1.5V15.1Zm2.15 5.8-1.75.35h-.3v-1.77h-.05c-1.13.86-2.5 1.75-4.35 1.75-1.64 0-3.36-1.18-3.36-3.49 0-3.11 2.79-3.54 4.3-3.76l3.36-.46v-.86c0-2.15-1.02-2.74-2.87-2.74-.7 0-2.44.21-3.87.86l-.24-1.99c1.18-.46 3.04-.81 4.51-.81 2.66 0 4.62 1.1 4.62 4.67v8.25Z"
                className="cls-1"
              />
            </g>
            <g id="g120">
              <path
                id="path122"
                d="M54.8 17.84c-1.05.75-2.39 1.5-3.57 1.5-1.1 0-1.83-.72-1.83-1.77 0-1.45 1.02-1.83 1.93-1.96l3.46-.51v2.74Zm2.15-5.18c0-3.57-1.96-4.67-4.62-4.67-1.48 0-3.33.35-4.51.81l.24 1.99c1.42-.64 3.17-.86 3.87-.86 1.85 0 2.87.59 2.87 2.74v.86l-3.36.46c-1.5.21-4.3.65-4.3 3.76 0 2.31 1.72 3.49 3.36 3.49 1.85 0 3.22-.89 4.35-1.75h.05v1.77h.3l1.75-.35v-8.25Z"
                className="cls-1"
              />
            </g>
            <g id="g124">
              <path id="path126" d="M69.79 21.25Z" className="cls-1" />
            </g>
            <g id="g128">
              <path
                id="path130"
                d="m71.67 7.98-1.88.4v12.86h.27l1.87-.4V7.98h-.27Z"
                className="cls-1"
              />
            </g>
            <g id="g132">
              <path
                id="path134"
                d="m71.67 3.62-1.88.4v2.27h.27l1.87-.4V3.6h-.27Z"
                className="cls-1"
              />
            </g>
            <g id="g136">
              <path
                id="path138"
                d="M88.86 13.69a1.071 1.071 0 0 1-2.14 0 1.071 1.071 0 0 1 2.14 0"
                className="cls-1"
              />
            </g>
            <g id="g140">
              <path
                id="path142"
                d="M23.17.77a.45.45 0 0 0-.32-.77h-6.73l3.91 3.91L23.17.77Z"
                className="cls-1"
              />
            </g>
            <g id="g144">
              <path
                id="path146"
                d="M13.77 10.18 8.96 5.37 4.63 9.7l-4.5 4.49c-.18.18-.18.46 0 .64l4.49 4.49 4.33 4.33 4.81-4.81-4.01-4.01-.32-.32.32-.32 4.01-4.01Z"
                className="cls-1"
              />
            </g>
            <g id="g148">
              <path
                id="path150"
                d="m20.03 25.1-3.9 3.9h6.7c.4 0 .61-.49.32-.77l-3.12-3.12Z"
                className="cls-1"
              />
            </g>
            <g id="g152">
              <path
                id="path154"
                d="M28.85 14.19 24.36 9.7 19.3 4.64 14.8.13a.439.439 0 0 0-.31-.13H6.14c-.4 0-.61.49-.32.77l3.86 3.86 4.81 4.81 4.74 4.74.32.32-.32.32-4.74 4.74-4.81 4.81-3.85 3.85a.45.45 0 0 0 .32.77h8.34c.12 0 .24-.05.32-.13l4.49-4.49 5.06-5.06 4.49-4.49c.18-.18.18-.46 0-.64"
                className="cls-1"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SatispayIcon;
